export const LOGIN_EMAIL = 'LOGIN_EMAIL';
export const OTP_SEND = 'OTP_SEND';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const VERIFY_CODE = 'VERIFY_CODE';
export const CODE_VERIFIED = 'CODE_VERIFIED';
export const CODE_VERIFICATION_ERROR = 'CODE_VERIFICATION_ERROR';

export const SELF_LOGIN = 'CODE_VERIFIED';
export const SELF_LOGIN_ERROR = 'SELF_LOGIN_ERROR';

export const RESET_USER = 'RESET_USER';

export const SET_APP_VERSION = 'SET_APP_VERSION';